import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { deleteTemplate } from '../../../../../api/user';
import { getUsers, setUserEmpty, userRoleData } from '../../../../../redux/slices/users';
import { useDispatch, useSelector } from '../../../../../redux/store';
import { ConfirmDialog } from '../../../../../reusable-components/confirm-dialog';
import CustomDataGrid from '../../../../../reusable-components/datagrid/CustomDataGrid';
import { TEMPLATES_COLUMNS } from '../../../../../reusable-components/datagrid/permissionColumns';
import CloseIconButton from '../../../../../reusable-components/basic-buttons/CloseIconButton';
import EditRoleModal from './EditRoleModal';
import LoadingAnimation from '../../../../../reusable-components/loader/LoadingAnimation';
import Iconify from '../../../../../reusable-components/iconify';

export default function RolesTemplateTab() {
  const dispatch = useDispatch();
  const { id = '' } = useParams();
  const [open, setOpen] = useState(false);

  const {
    data: { userRoleTemplates, user, users },
  } = useSelector((state) => state.users);

  const { isLoading } = useSelector((state) => state.users);

  const handleDelete = async (templateId) => {
    await deleteTemplate(templateId);
    dispatch(setUserEmpty());
    dispatch(getUsers());
    dispatch(userRoleData(id, 1));
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const ActionButtons = (params) => {
    const { id, isLocked } = params.row;
    return (
      <>
        <Box>
          <EditRoleModal row={params.row} />
        </Box>
        <ConfirmDialog
          icon="delete-outline"
          title="Delete"
          color="error"
          content={`Are you sure you want to delete this template?`}
          actionButton="Delete"
          action={() => handleDelete(id)}
          disabled={isLocked}
        />
      </>
    );
  };

  const actions = {
    field: 'actions',
    headerName: 'Actions',
    disableReorder: true,
    sortable: false,
    width: 100,
    renderCell: (params) => ActionButtons(params),
    id: 'actions',
    className: 'actions',
  };

  const CustomLeftToolbar = useCallback(
    () => (
      <>
        <Box>
          <EditRoleModal
            row={{
              id: undefined,
              name: 'New Template',
              isLocked: false,
              useUserFacility: false,
            }}
            newTemplate
          />
        </Box>
      </>
    ),
    []
  );

  return (
    <>
      <Button
        onClick={() => handleClickOpen()}
        size="small"
        color="secondary"
        variant="outlined"
        sx={{ mr: 1 }}
        startIcon={<Iconify icon="mdi:account-box-multiple-outline" color="secondary" />}
      >
        Role Templates
      </Button>
      {open && (
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
            handleClose();
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              textAlign: 'center',
            }}
          >
            User Templates
            <CloseIconButton onClick={handleClose} />
          </DialogTitle>
          <DialogContent sx={{ height: '100%', width: '100%' }}>
            <Grid item>
              {user && users.length && !isLoading ? (
                <CustomDataGrid
                  gridId="templates"
                  isModal
                  data={userRoleTemplates}
                  gridColumns={[...TEMPLATES_COLUMNS, actions]}
                  CustomLeftToolbar={CustomLeftToolbar}
                  dontGetRowHeight
                  sort={[{ field: 'name', sort: 'asc' }]}
                />
              ) : (
                <Box sx={{ justifySelf: 'center' }}>
                  <LoadingAnimation />
                </Box>
              )}
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
